<div id="control-screen" *ngIf="checkIDState === 1">
  <div class="donateshow" *ngIf="donateState === 1 && !isSecondPatronTurn">
    <!-- <img src="https://i.imgur.com/MMZ2TvB.jpg" id="patron" /> -->
    <!-- <img src="https://i.imgur.com/iFzdRgk.jpeg" id="patron"> -->
    <img src={{currentDonate.pic1}} id="patron">
  </div>
  <div class="donateshow" *ngIf="donateState === 1 && isSecondPatronTurn">
    <img src={{currentDonate.pic2}} id="patron">
  </div>

  <div class="donateshow" *ngIf="donateState === 2">
    <img src={{settingData.img4}} id="donate-img">
    <div class="donate-text">非常感謝 <span id="money"> {{currentDonate.name}} </span>
      贊助 <span id="money">{{currentDonate.donate}}</span> 元!!</div>
    <div class="donate-text">{{currentDonate.msg}}</div>
  </div>
</div>
